<template>
    <div>      
        <v-snackbar 
            color="error"
            v-model="app.merkato.initializeError">
            Het document kon niet worden geopend.
            <v-btn
                text
                @click="app.merkato.initializeError = false">
                <v-icon small color="white">mdi-close</v-icon>
            </v-btn>
        </v-snackbar>

    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["app"])
  }
};
</script>
